import { subscriptionStatuses } from "./constants/subscriptionStatuses";

function subscriptionActiveStatus(subscription) {
  if (!subscription.suspension_waiting) return subscriptionStatuses.subscribed;

  switch (subscription.restart_at) {
    case null:
      if (subscription.closet_blocking_cancelation) return subscriptionStatuses.subscribedWaitingForCancelationBlockedByCloset;

      return subscriptionStatuses.subscribedWaitingForCancelation;
    default:
      if (subscription.closet_blocking_cancelation) return subscriptionStatuses.subscribedWaitingForPauseBlockedByCloset;

      return subscriptionStatuses.subscribedWaitingForPause;
  }
}

function subscriptionPastDueStatus(subscription) {
  if (!subscription.suspension_waiting) return subscriptionStatuses.pastDue;

  switch (subscription.restart_at) {
    case null:
      return subscriptionStatuses.pastDueWaitingForCancelation;
    default:
      return subscriptionStatuses.pastDueWaitingForPause;
  }
}

function subscriptionCanceledStatus(subscription) {
  switch (subscription.restart_at) {
    case null:
      return subscriptionStatuses.canceled;
    default:
      return subscriptionStatuses.paused;
  }
}

export default function subscriptionStatus(subscription) {
  const subscriptionState = subscription?.state;

  switch (subscriptionState) {
    case "waiting":
    case "incomplete":
      return subscriptionStatuses.notSubscribed;
    case "trialing":
    case "active":
      return subscriptionActiveStatus(subscription)
    case "past_due":
      return subscriptionPastDueStatus(subscription);
    case "canceled":
      return subscriptionCanceledStatus(subscription);
    default:
      return subscriptionStatuses.notSubscribed;
  }
}
